/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { FunctionComponent, ReactElement } from 'react';
import ArticleCard, { ArticleCardProps, ArticleCardSkeleton } from '../article-card/ArticleCard';
import * as styles from './ArticlesList.style';

interface ArticleEntry extends ArticleCardProps {
  id: string,
}

export interface ArticleListSkeletonProps {
  totalItems?: Number,
}

export const ArticlesListSkeleton: FunctionComponent<ArticleListSkeletonProps> = ({
  totalItems = 4,
}) => (
  <div>
    {Array(totalItems).map((value) => (
      <div
        key={`article-card-skeleton-${value}`}
        css={styles.item}
      >
        <ArticleCardSkeleton />
      </div>
    ))}
  </div>
);

export interface ArticleListProps {
  articles: ArticleEntry[],
  dataRef?: string,
  render?: {
    inPosition: (index: Number) => ReactElement,
  },
}

const ArticlesList: FunctionComponent<ArticleListProps> = ({
  articles,
  dataRef = 'articles-list',
  render,
}) => (
  <div data-ref={dataRef}>
    <ul data-ref={`${dataRef}-items`}>
      {articles.map((article, index) => (
        <React.Fragment key={article.id}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <li
            data-ref={`${dataRef}-item`}
            css={styles.item}
          >
            <ArticleCard {...article} />
          </li>
          {render?.inPosition(index)}
        </React.Fragment>
      ))}
    </ul>
  </div>
);

export default ArticlesList;
